module.exports = __webpack_public_path__ + "static/img/entranceHoverIcon.97656b9.4c8bdfa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/entranceHoverIcon.97656b9.gif
// module id = VIU9
// module chunks = 0